import {Injectable} from '@angular/core'
import {FIVE_MINUTES} from "../../../domain/src/lib/calendar.model"


@Injectable({
  providedIn: 'root',
})
export class DateService {
  changeDay(selectedDate: Date, days: number): Date {
    // const adjustedDate = this.adjustDateByDays(selectedDate, days)
    // console.debug('DateService#changeDay: selectedDate=', selectedDate, ', days=', days)
    // console.debug('DateService#changeDay: adjustedDate=', adjustedDate)
    // const isoDate = convertToISODateString(adjustedDate)
    // console.debug('DateService#changeDay: isoDate=', isoDate)
    return this.adjustDateByDays(selectedDate, days)
  }


  changeMonth(selectedDate: Date, months: number): Date {
    // const adjustedDate = this.adjustDateByMonths(selectedDate, months)
    // console.debug('DateService#changeMonth: selectedDate=', selectedDate, ', days=', months)
    // console.debug('DateService#changeMonth: adjustedDate=', adjustedDate)
    // const isoDate = convertToISODateString(adjustedDate)
    // console.debug('DateService#changeMonth: isoDate=', isoDate)
    return this.adjustDateByMonths(selectedDate, months)
  }


  toDay(): Date {
    // const today = new Date()
    return new Date()
  }


  private adjustDateByDays(date: Date, days: number): Date {
    const newDate = new Date(date)
    newDate.setDate(date.getDate() + days)
    return newDate
  }


  private adjustDateByMonths(date: Date, months: number): Date {
    const newDate = new Date(date)
    newDate.setMonth(newDate.getMonth() + months) // Use setMonth to adjust months
    return newDate
  }


  convertToDate(date: Date | string): Date {
    return new Date(date)
  }

  getSundayOfWeek(date: Date): Date {
    const dayOfWeek = date.getDay()
    const daysUntilSunday = dayOfWeek === 0 ? 0 : 7 - dayOfWeek
    return this.adjustDateByDays(date, daysUntilSunday)
  }

  addMinutesToDate(date: Date | string | undefined, minutes: number): Date {
    // console.debug('admin-calendar#addMinutes: date=', date, ', minutes=', minutes)
    let newDate: Date
    switch (typeof date) {
      case 'object':
        newDate = new Date(date)
        break
      case 'string':
        newDate = new Date(date.toString().replace('Z', ''))
        break
      case 'undefined':
        newDate = new Date()
        break
      default:
        newDate = new Date()
        break
    }
    // const newDate = date === undefined ? new Date() : new Date(date)
    // const newDate = new Date(date)
    // console.debug('DateService#addMinutesToDate: newDate=', newDate)
    newDate.setMinutes(newDate.getMinutes() + minutes)
    // console.debug('DateService#addMinutesToDate: newDate=', newDate)
    return newDate
  }


  subMinutesToDate(date: Date, minutes: number): Date {
    return this.addMinutesToDate(date, -minutes)
  }


  addSecondsToDate(date: Date, seconds: number): Date {
    return this.addMinutesToDate(date, Math.ceil(seconds.valueOf() / 60))
  }


  subSecondsToDate(date: Date, seconds: number): Date {
    return this.addSecondsToDate(date, -seconds)
  }


  roundDateTo(date: Date, to: number = FIVE_MINUTES): Date {
    // const ms = date?.valueOf() ?? new Date().valueOf()
    const ms = date?.valueOf() ?? Date.now()
    const roundedMs = Math.round(ms / to) * to
    return new Date(roundedMs)
  }


  roundDownDateTo(date: Date | undefined, to: number = FIVE_MINUTES): Date {
    const newDate = date === undefined ? new Date() : new Date(date)
    // const ms = newDate?.valueOf() ?? new Date().valueOf()
    const ms = newDate?.valueOf() ?? Date.now()
    const roundedMs = Math.floor(ms / to) * to
    return new Date(roundedMs)
  }


  roundUpDateTo(date: Date, to: number = FIVE_MINUTES): Date {
    // const ms = date?.valueOf() ?? new Date().valueOf()
    const ms = date?.valueOf() ?? Date.now()
    const roundedMs = Math.ceil(ms / to) * to
    return new Date(roundedMs)
  }


  /*
   // TODO: refactor this
   // (onInput)="handleUpdateAppointmentTime($event)"
   handleUpdateAppointmentTime0(event?: any) {
   // Parse only when we have enough info; don't force-complete on "5." so user can continue with "5.10".
   const inputEl: HTMLInputElement | undefined = event?.target as HTMLInputElement | undefined
   const raw = (inputEl?.value ?? '').trim()
   if (!raw) {
   return
   }

   // Don't complete while user is at "d." (e.g., "5.")
   if (/^\d{1,2}\.$/.test(raw)) {
   return
   }

   const completed = this.tryCompletePartialDate(raw)
   if (!completed) {
   return
   }

   const withTime = this.mergeWithTime(completed, raw)

   // Update only the model; do not rewrite input while typing to avoid blocking the user
   if (!this.appointmentAt || this.appointmentAt.getTime() !== withTime.getTime()) {
   this.appointmentAt = withTime
   }
   // Formatting/rounding stays onBlur via handleSetAppointmentTime()
   }


   private tryCompletePartialDate(input: string): Date | null {
   // Normalize separators and spaces
   const str = input.replace(/\s+/g, ' ').toLowerCase()

   // Extract time (optional)
   const timeMatch = str.match(/(\d{1,2})[:.](\d{2})\s*$/)
   const timePart = timeMatch ? timeMatch[0] : ''
   const datePart = timeMatch ? str.slice(0, str.length - timePart.length).trim() : str

   // Hold off on "d." so user can type the month (e.g., "5." -> continue to "5.10")
   if (/^\d{1,2}\.$/.test(datePart)) {
   return null
   }

   // 1) d.m (no trailing dot, no year) -> assume current year
   let m = datePart.match(/^(\d{1,2})\.(\d{1,2})$/)
   if (m) {
   const day = parseInt(m[1], 10)
   const month = parseInt(m[2], 10)
   const now = new Date()
   return this.safeDate(now.getFullYear(), month - 1, day)
   }

   // 2) d.m. (with trailing dot) -> also assume current year
   m = datePart.match(/^(\d{1,2})\.(\d{1,2})\.$/)
   if (m) {
   const day = parseInt(m[1], 10)
   const month = parseInt(m[2], 10)
   const now = new Date()
   return this.safeDate(now.getFullYear(), month - 1, day)
   }

   // 3) d.m.yyyy or d.m.yy
   m = datePart.match(/^(\d{1,2})\.(\d{1,2})\.(\d{2,4})$/)
   if (m) {
   const day = parseInt(m[1], 10)
   const month = parseInt(m[2], 10)
   let year = parseInt(m[3], 10)
   if (year < 100) {
   const nowYear = new Date().getFullYear()
   const century = Math.floor(nowYear / 100) * 100
   const guess = century + year
   year = Math.abs(guess - nowYear) <= 30 ? guess : year
   }
   return this.safeDate(year, month - 1, day)
   }

   // 4) Single number might be day (e.g., "5") -> assume current month/year
   m = datePart.match(/^(\d{1,2})$/)
   if (m) {
   const day = parseInt(m[1], 10)
   const now = new Date()
   return this.safeDate(now.getFullYear(), now.getMonth(), day)
   }

   // 5) dd.mm.yyyy (already full date)
   m = datePart.match(/^(\d{2})\.(\d{2})\.(\d{4})$/)
   if (m) {
   const day = parseInt(m[1], 10)
   const month = parseInt(m[2], 10)
   const year = parseInt(m[3], 10)
   return this.safeDate(year, month - 1, day)
   }

   return null
   }


   private mergeWithTime(baseDate: Date, rawInput: string): Date {
   // If user typed time, use it. Else, reuse existing time if present; otherwise round current time.
   const timeMatch = rawInput.replace(/\s+/g, ' ').match(/(\d{1,2})[:.](\d{2})\s*$/)
   let hours: number
   let minutes: number

   if (timeMatch) {
   hours = Math.min(23, parseInt(timeMatch[1], 10))
   minutes = Math.min(59, parseInt(timeMatch[2], 10))
   } else if (this.appointmentAt instanceof Date) {
   hours = this.appointmentAt.getHours()
   minutes = this.appointmentAt.getMinutes()
   } else {
   const now = new Date()
   hours = now.getHours()
   minutes = now.getMinutes()
   const step = 5
   const rounded = Math.round(minutes / step) * step
   minutes = rounded === 60 ? 0 : rounded
   if (rounded === 60) {
   hours = (hours + 1) % 24
   }
   }

   const res = new Date(baseDate)
   res.setHours(hours, minutes, 0, 0)
   return res
   }


   private safeDate(year: number, monthIndex: number, day: number): Date {
   const d = new Date(year, monthIndex, day, 0, 0, 0, 0)
   if (d.getFullYear() !== year || d.getMonth() !== monthIndex || d.getDate() !== day) {
   return d
   }
   return d
   }


   private formatDeChDateTime(d: Date): string {
   // Format as dd.MM.yyyy HH:mm for immediate visual feedback
   const pad = (n: number) => (n < 10 ? '0' + n : '' + n)
   const day = pad(d.getDate())
   const month = pad(d.getMonth() + 1)
   const year = d.getFullYear()
   const hours = pad(d.getHours())
   const minutes = pad(d.getMinutes())
   return `${day}.${month}.${year} ${hours}:${minutes}`
   }
   */

}
